import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { UNRESTRICTED_SPORTS } from "helpers/constants";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import { Plus } from "mdi-material-ui";
import React from "react";

import LeaguesForm from "./Form";

AddLeagueDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Add League",
  };
};

export default function AddLeagueDialog({ orgId = null, competitionId = null, onSubmit, onClose }) {
  const addLeague = useActionFragment("addLeague", "league { id }");
  const [data, dataMeta] = useData(
    gql`
      query AddLeagueDialogQuery($orgId: ID) {
        org(id: $orgId) {
          id
          allowEncodeHighQualityOutputs
          defaultForNewLeagueAdPreset {
            id
          }
          primarySport
        }
      }
    `,
    { orgId },
  );
  const isAdmin = useIsAdmin();

  const orgSport = data?.org?.primarySport;
  const initialSport =
    isAdmin !== false || !orgSport || UNRESTRICTED_SPORTS.includes(orgSport) ? orgSport : "basketball";

  return (
    <FormDialog
      header="Add League"
      loading={dataMeta.loading || isAdmin === undefined}
      onClose={onClose}
      onSubmit={async (formData) => {
        const result = await addLeague({
          input: formData,
        });
        await onSubmit?.(result.addLeague.league);
      }}
    >
      <LeaguesForm
        leagues={[
          {
            org: orgId && {
              id: orgId,
              allowEncodeHighQualityOutputs: data?.org?.allowEncodeHighQualityOutputs,
              __typename: "Org",
            },
            competition: competitionId && { id: competitionId, __typename: "Competition" },
            sport: initialSport,
            adPreset: data?.org?.defaultForNewLeagueAdPreset,
          },
        ]}
      />
    </FormDialog>
  );
}
